<script>
import StatusDot from "../elements/StatusDot";

export default {
     mixins: [StatusDot],
    props: { value: {} },
    computed: {
        label() {
            return ''
        },
        shouldShowRed() {
            return this.value === 'red'
        },
        shouldShowOrange() {
            return this.value === 'orange'
        },
        shouldShowGreen() {
            return this.value === 'green'
        }
    }
}
</script>